
import { defineComponent, PropType } from 'vue'
import useRoll from './useRoll'
import { RollType, SkillProgress } from '@/types'
import { Button } from '@/shared/ui'
import RollResult from '@/shared/ui/RollResult/RollResult.vue'
import RollDifficulty from '@/features/RollSkillDice/part/RollDifficulty.vue'
import SkillBubble from '@/features/RollSkillDice/part/SkillBubble.vue'

export default defineComponent({
	name: 'RollAttack',
	components: {
		SkillBubble,
		RollDifficulty,
		RollResult,
		Button
	},
	props: {
		skill: {
			type: Object as PropType<SkillProgress>,
			required: true
		},
		rollType: {
			type: String as PropType<RollType>,
			required: true
		}
	},
	setup(props) {
		return useRoll(props.skill, props.rollType)
	},
	data() {
		return {
			isHitPreRolled: false,
			isHitRolled: false
		}
	},
	methods: {
		preRollForHit() {
			this.roll(false)
			this.isHitPreRolled = true
		},
		rollForHit() {
			this.resultValue = this.calculateResult()
			this.addExperience()
			if (this.resultValue <= 0) {
				this.isHitPreRolled = false
				return
			}
			this.isHitRolled = true
		},
		rollForDamage() {
			this.difficulty = 0
			this.roll(false)
			this.isHitPreRolled = false
			this.isHitRolled = false
		}
	}
})
